import { platform, PlatformType } from "../../bud-lite-tv/src/lib";
import { WebOSHelper } from "./lgHelper";
import { TizenHelper } from "./tizenHelper";

export const DecommissionHelper = {
  launchAppFTV() {
    console.log("launchAppFTV");
    console.log("platform.type", platform.type);
    if (platform.type === PlatformType.tizen) {
      TizenHelper?.launchAppFTV();
    }
    if (platform.type === PlatformType.hisense) {
      window.location.href = "https://hisense-smart-tv.yatta.francetv.fr/";
    }
    if (platform.type === PlatformType.philips) {
      //try altenative way to launch Philips app store
      window.location.href = "https://philips-smart-tv.yatta.francetv.fr/";
    }
    if (platform.type === PlatformType.webos) {
      WebOSHelper?.launchAppFTV();
    }
  },
};
